import React from "react";

const BasindaBiz = () => {
  const newsArticles = [
    {
      title: "Bursa’da Zekai Gümüşdiş Ortaokulu’ndan çevreye duyarlı eğitim hamlesi",
      date: "18 Aralık 2024",
      source: "Olay Gazetesi",
      url: "https://www.olay.com.tr/bursada-zekai-gumusdis-ortaokulundan-cevreye-duyarli-egitim-hamlesi-1395252",
      image: "https://www.olay.com.tr/wp-content/uploads/2024/12/zekaigumusdis-ortaokulu2-cvic.jpeg",
    },
    {
      title: "Bursa Zekai Gümüşdiş Ortaokulu’ndan çevreye duyarlı eğitim hamlesi",
      date: "18 Aralık 2024",
      source: "Bursa Hakimiyet Portalı",
      url: "https://www.bursahakimiyet.com.tr/bursa/bursa-zekai-gumusdis-ortaokulu-ndan-cevreye-duyarli-egitim-hamlesi-1363801",
      image: "https://www.bursahakimiyet.com.tr/cdn/TT8Tj5eRxEOWDzgcN0JTLABRQ5U=/750x500/webp/2024/12/17/bursa-zekai-gumusdis-ortaokulu-ndan-cevreye-duyarli-egitim-hamlesi-1734424822-728_large.webp",
    },
    {
      title: "Bursa'da Zekai Gümüşdiş Ortaokulu'ndan çevreye duyarlı eğitim hamlesi",
      date: "18 Aralık 2024",
      source: "Bursada Bugün Gazetesi",
      url: "https://www.bursadabugun.com/haber/bursa-da-zekai-gumusdis-ortaokulu-ndan-cevreye-duyarli-egitim-hamlesi-1773449.html",
      image: "https://images.bursadabugun.com/haber/2024/12/17/1773449-bursa-da-zekai-gumusdis-ortaokulu-ndan-evreye-duyarli-egitim-hamlesi-676139e52d946.jpeg",
    }, 
     {
      title: "Zekai Gümüşdiş Ortaokulu, Erasmus+ Projesi ile Çevre Bilinci Kazanıyor",
      date: "18 Aralık 2024",
      source: "Söz Bursa Gazetesi",
      url: "https://www.sozbursa.com/egitim/zekai-gumusdis-ortaokulu-erasmus-projesi-ile-cevre-bilinci-kazaniyor-247090",
      image: "https://www.sozbursa.com/cdn/TV5ekuOM34f70A67lR6K6ZxRytI=/750x500/webp/2024/12/17/zekai-gumusdis-ortaokulu-erasmus-projesi-ile-cevre-bilinci-kazaniyor-1734428674-400_large.webp",
    },
  
    {
      title: "Zekai Gümüşdiş Ortaokulu’ndan çevreye duyarlı eğitim hamlesi!",
      date: "17 Aralık 2024",
      source: "Bursa Hayat Gazetesi",
      url: "https://www.bursahayat.com.tr/bursa/zekai-gumusdis-ortaokulu-ndan-cevreye-duyarli-egitim-hamlesi-655681",
      image: "https://www.bursahayat.com.tr/static/2024/12/17/zekai-gu-mu-s-dis-ortaokulu-2-b-vic-1734425827-757-x750.jpeg",
    },
  ];

  return (
    <div style={{ padding: "20px" }}>
      <h1 style={{ textAlign: "center", marginBottom: "30px" }}>Basında Biz</h1>
      <ul
        style={{
          listStyleType: "none",
          padding: 0,
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(300px, 1fr))",
          gap: "20px",
        }}
      >
        {newsArticles.map((article, index) => (
          <li
            key={index}
            style={{
              border: "1px solid #ccc",
              borderRadius: "10px",
              padding: "15px",
              boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
              textAlign: "center",
            }}
          >
            <img
              src={article.image}
              alt={article.title}
              style={{
                width: "100%",
                maxWidth: "100%",
                height: "auto",
                objectFit: "cover",
                borderRadius: "10px",
                marginBottom: "15px",
              }}
            />
            <h3>{article.title}</h3>
            <p>
              <strong>Tarih:</strong> {article.date}
            </p>
            <p>
              <strong>Kaynak:</strong> {article.source}
            </p>
            <a
              href={article.url}
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#007bff",
                textDecoration: "none",
                fontWeight: "bold",
              }}
            >
              Haberi Oku
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default BasindaBiz;
